<template>
  <a href="https://metrika.yandex.ru/stat/?id=83398558&amp;from=informer" target="_blank" rel="nofollow">
    <img
      src="https://informer.yandex.ru/informer/83398558/3_1_FFFFFFFF_EFEFEFFF_0_pageviews"
      style="width:88px; height:31px; border:0;" alt="Яндекс.Метрика"
      title="Яндекс.Метрика: данные за сегодня (просмотры, визиты и уникальные посетители)" class="ym-advanced-informer"
      data-cid="83398558" data-lang="ru"/>
  </a>
</template>
<script>
(function (m, e, t, r, i, k, a) {
  m[i] = m[i] || function () {
    (m[i].a = m[i].a || []).push(arguments)
  };
  m[i].l = 1 * new Date();
  k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(83398558, "init", {defer: true, clickmap: true, trackLinks: true, accurateTrackBounce: true, trackHash: true});
ym(83398558, "hit", window.location.href);
</script>
<!--<script>-->
<!--export default {-->
<!--  data: () => ({-->
<!--    content: []-->
<!--  }),-->
<!--  mounted() {-->
<!--    this.content = '<a href="https://metrika.yandex.ru/stat/?id=83398558&amp;from=informer" target="_blank"\n' +-->
<!--      '  rel="nofollow"><img\n' +-->
<!--      '  src="https://informer.yandex.ru/informer/83398558/3_1_FFFFFFFF_EFEFEFFF_0_pageviews"\n' +-->
<!--      '  style="width:88px; height:31px; border:0;" alt="Яндекс.Метрика"\n' +-->
<!--      '  title="Яндекс.Метрика: данные за сегодня (просмотры, визиты и уникальные посетители)" class="ym-advanced-informer"\n' +-->
<!--      '  data-cid="83398558" data-lang="ru"/></a>\n' +-->
<!--      '<script type="text/javascript"> (function (m, e, t, r, i, k, a) {\n' +-->
<!--      '  m[i] = m[i] || function () {\n' +-->
<!--      '    (m[i].a = m[i].a || []).push(arguments)\n' +-->
<!--      '  };\n' +-->
<!--      '  m[i].l = 1 * new Date();\n' +-->
<!--      '  k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)\n' +-->
<!--      '})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");\n' +-->
<!--      'ym(83398558, "init", {defer: true, clickmap: true, trackLinks: true, accurateTrackBounce: true, trackHash: true, triggerEvent: true,}); \n' +-->
<!--      // 'ym(83398558, "hit", window.location.href); \n' +-->
<!--      '<\/script>' +-->
<!--      '<noscript>\n' +-->
<!--      '<div><img src="https://mc.yandex.ru/watch/83398558" style="position:absolute; left:-9999px;" alt=""/></div>\n' +-->
<!--      '</noscript>\n'-->
<!--    this.$metrika.hit(this.$router.currentRoute.path)-->
<!--  }-->
<!--}-->
<!--</script>-->

